import { Container, Row, Col } from 'react-bootstrap';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';

import {
  breadcrumbsLinks,
  hyperLinks,
} from '../../../../../constants/Constants';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <Container className="main-container p-0">
      <Row>
        <Col xs={12} md={12}>
          <Breadcrumbs links={breadcrumbsLinks.termsAndConditions} />
          <h3 className="main-heading" data-testid="terms-and-condition">
            Terms & Conditions
          </h3>
          <div className="main-content">
            <h3>Respecting your privacy</h3>
            <p>
              Unless otherwise stated, The National Highways web site does not
              automatically store or capture personal information.
            </p>
            <p>
              On occasions where personal information is requested, users will
              be informed about how their personal details will be used and how
              long this information will be retained for. In all cases, unless
              clearly stated otherwise, personal information will not be used
              for any other purpose.
            </p>
            <p>
              The system will record your e-mail address and other information
              only if volunteered to us by you. This shall be treated as
              proprietary and confidential. It may be used for internal review
              or to notify you about updates to the National Highways web site.
            </p>
            <p>
              We do not use cookies, and we will not collect any information
              about you except as outlined above.
            </p>
            <p>
              This privacy statement only covers the National Highways web site.
              Links within this site to other web sites are not covered by this
              statement.
            </p>
            <p>
              If you want to know whether any information is held about you,
              please see our policy under the Data Protection Act 2018.
            </p>
            <h3>Site disclaimer</h3>
            <p>
              The National Highways web site and material relating to Government
              information, products and services (or to third party information,
              products and services), is provided 'as is', without any
              representation or endorsement made and without warranty of any
              kind whether express or implied, including but not limited to the
              implied warranties of satisfactory quality, fitness for a
              particular purpose, non-infringement, compatibility, security and
              accuracy.
            </p>
            <p>
              We do not warrant that the functions contained in the material
              contained in this site will be uninterrupted or error free, that
              defects will be corrected, or that this site or the server that
              makes it available are free of viruses or represent the full
              functionality, accuracy, reliability of the materials. In no event
              will we be liable for any loss or damage including, without
              limitation, indirect or consequential loss or damage, or any loss
              or damages whatsoever arising from use or loss of use of, data or
              profits arising out of or in connection with the use of The
              National Highways web site.
            </p>
            <p>
              These Terms and Conditions shall be governed by and construed in
              accordance with the laws of England and Wales. Any dispute arising
              under these Terms and Conditions shall be subject to the exclusive
              jurisdiction of the courts of England and Wales.
            </p>
            <h3>Cookies</h3>
            <p>
              This site uses 'third-party' cookies to make sure it meets the
              users' needs and to understand how we could do better. For more
              information see our{' '}
              <Link
                data-testid="cookies-policy-link"
                to={hyperLinks.cookiesPolicy}
                className="underlined-colorlink"
              >
                cookie policy.
              </Link>
            </p>
            <h3>Crown copyright</h3>
            <p>© Crown copyright, 2012.</p>
            <p>
              You may use and re-use the information featured on this website
              (not including logos) free of charge in any format or medium,
              under the terms of the Open Government Licence with only a few
              conditions.We encourage users to establish hypertext links to this
              website.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsConditions;
